export default __webpack_public_path__ + "static/media/catlogo.c6f6c1dc.png";